import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && user !== false) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(apiErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="flex min-h-screen items-center justify-center bg-aero-deep px-5">
      <div className="w-full max-w-md rounded-2xl border border-steel/20 bg-aero-surface p-8 sm:p-10">
        <div className="mb-8 text-center">
          <span className="mx-auto grid h-12 w-12 place-items-center rounded-full border border-saffron/40 bg-aero-navy text-saffron">
            <Lock className="h-5 w-5" />
          </span>
          <h1 className="mt-4 font-heading text-2xl font-bold tracking-tight text-ink">Admin Login</h1>
          <p className="mt-1 font-body text-sm text-steel">Sharma Model Aero — site management</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <input
            data-testid="admin-login-email"
            type="email"
            required
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-lg border border-steel/25 bg-white px-4 py-3 font-body text-sm text-ink outline-none transition-colors focus:border-saffron"
          />
          <input
            data-testid="admin-login-password"
            type="password"
            required
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-lg border border-steel/25 bg-white px-4 py-3 font-body text-sm text-ink outline-none transition-colors focus:border-saffron"
          />
          {error && (
            <p data-testid="admin-login-error" className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 font-body text-xs text-red-600">
              {error}
            </p>
          )}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={busy}
            className="flex w-full items-center justify-center gap-2 rounded-full bg-saffron py-3 font-heading font-semibold text-white transition-colors hover:bg-saffron-soft disabled:opacity-60"
          >
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
